import { render, staticRenderFns } from "./DialogSelector.vue?vue&type=template&id=f5126f28&scoped=true&"
import script from "./DialogSelector.vue?vue&type=script&lang=ts&"
export * from "./DialogSelector.vue?vue&type=script&lang=ts&"
import style0 from "./DialogSelector.vue?vue&type=style&index=0&id=f5126f28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5126f28",
  null
  
)

export default component.exports